import { makeStyles } from '@material-ui/core';
import clsx from 'clsx';
import { useHiwScroll, currentFrame } from './hooks/scrollFramePlayer';

interface Props {
    className: string;
}
const W = 50;
const H = 37.5;
const MAX_WIDTH = 800;
const MAX_HEIGHT = (MAX_WIDTH * H) / W;
const useStyles = makeStyles((theme) => ({
    root: {
        width: `${W}vw`,
        height: `${H}vw`,
        position: 'fixed',
        right: 0,
        [theme.breakpoints.up('lg')]: {
            right: `calc(50vw - ${MAX_WIDTH}px)`
        },
        maxWidth: MAX_WIDTH,
        maxHeight: MAX_HEIGHT
    }

    // p1: {
    //     width: `${0.159375 * 50}vw`,
    //     left: `27.213541666666667vw`,
    //     top: `${(100 / 1440) * H}vw`,
    //     position: 'absolute'
    // }
}));

const VisionAnimation = ({ className }: Props) => {
    // const videoRef = usePlayer();
    const classes = useStyles();
    // const ref = useRef<HTMLObjectElement | null>();
    // const animatedPart = useRef<Record<string, HTMLElement | null | undefined>>({});
    // const onScroll = () => {
    // animatedPart.current['green'].style.transform = `translate(0,${window.scrollY / 10}px)`;
    // animatedPart.current['pink'].style.transform = `translate(0,${window.scrollY / 10}px)`;
    // animatedPart.current['purple'].style.transform = `translate(0,${window.scrollY / 10}px)`;
    // };

    // const setRef = (node) => {
    //     if (node && !ref.current) {
    //         console.log(node.contentDocument);
    //         node.addEventListener(
    //             'load',
    //             function () {
    //                 // get the inner DOM of alpha.svg
    //                 animatedPart.current['green'] = node.contentDocument?.getElementById('green');
    //                 animatedPart.current['pink'] = node.contentDocument?.getElementById('pink');
    //                 animatedPart.current['purple'] = node.contentDocument?.getElementById('purple');
    //                 window.addEventListener('scroll', onScroll);
    //             },
    //             false
    //         );

    //         ref.current = node;
    //     }
    // };
    // useEffect(() => {
    //     return () => {
    //         window.removeEventListener('scroll', onScroll);
    //     };
    // }, []);

    useHiwScroll();
    return (
        <>
            <img className={clsx(classes.root, className)} src="/images/vision/puzzle.159.png" />
            <img
                src={currentFrame(1)}
                id="puzzle-animation"
                className={clsx(classes.root, className)}
            />
        </>
    );

};

export default VisionAnimation;
// <video
//     ref={videoRef}
//     autoPlay
//     className={clsx(classes.root, className)}
//     muted
//     preload="auto">
//     <source {...visionImages.video[0]} />
// </video>
